import { render, staticRenderFns } from "./AttachView.vue?vue&type=template&id=1901f762&"
import script from "./AttachView.vue?vue&type=script&lang=js&"
export * from "./AttachView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports